import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import ApiKeysEdit from './ApiKeysEditForm';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { fetchApiKey } from 'store/actions/apiKeys/fetchApiKeys';
import { updateApiKey } from 'store/actions/apiKeys/updateApiKeys';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import LoadingCard from 'components/loading/LoadingCard';

class ApiKeysEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            id,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                callback: (error) => {
                    if (error) {
                        // This location should have where we bounce the error back to the form with SubmissionError.
                        resolve();
                    }

                    resolve(history.push('/api-keys'));
                },
                values: values,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('menu.sidebar.api-keys'),
                link: '/api-keys',
            },
            {
                label: data.name,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.api-keys.actions.edit', { title: data.name }) } />

                    <Actions>
                        <ListButton url='/api-keys' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <ApiKeysEdit
                            data={ data }
                            form='api_keys_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

ApiKeysEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    id: PropTypes.number,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateApiKey(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceById({
        resource: 'api-keys',
        action: fetchApiKey,
    })
);

export default enhance(ApiKeysEditContainer);



// WEBPACK FOOTER //
// ./src/pages/api-keys/edit/ApiKeysEditContainer.js